
var ERROR = -1;
var NO_STATE = 0;
var SAVE_OK = 1;
var NOT_SAVED = 2;
var WAITING = 3;

function ActionStates() {
  this.state = NO_STATE;
}

ActionStates.prototype.setState = function(state) {
  this.state = state;
};

ActionStates.prototype.is = function(state) {
  return this.state === state;
};

ActionStates.prototype.reset = function() {
  this.setState(NO_STATE)
};

ActionStates.prototype.notSaved = function() {
  this.setState(NOT_SAVED)
};

ActionStates.prototype.isNotSaved = function() {
  return this.is(NOT_SAVED)
};


ActionStates.prototype.saveOk = function() {
  this.setState(SAVE_OK)
};

ActionStates.prototype.isSaveOk = function() {
  return this.is(SAVE_OK)
};

ActionStates.prototype.error = function() {
  this.setState(ERROR)
};

ActionStates.prototype.isError = function() {
  return this.is(ERROR)
};

ActionStates.prototype.waiting = function() {
  this.setState(WAITING)
};

ActionStates.prototype.isWaiting = function() {
  return this.is(WAITING)
};

module.exports = {
  StateClass: ActionStates,
  ERROR: ERROR,
  NO_STATE: NO_STATE,
  SAVE_OK: SAVE_OK,
  NOT_SAVED: NOT_SAVED,
  WAITING: WAITING
};



// WEBPACK FOOTER //
// ./client/src/app/utils/action-states.js